import { OccupationTiss } from '../../../models/tables/accreditation/occupation-tiss';

import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApiGateway } from 'cw-backend';
import { SnackBarService } from 'cw-utils';

@Injectable()
export class OccupationTissEditProvider implements Resolve<any>
{
    routeParams: any;
    state: any;
    onDataChanged: BehaviorSubject<any>;
    occupationTiss: OccupationTiss;

    constructor(
        public gw: ApiGateway,
        public snackBar: SnackBarService
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        return new Promise<void>((resolve, reject) => {
            Promise.all([this.getOccupationTiss()]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }

    getOccupationTiss(): Promise<any> {
        return new Promise((resolve, reject) => {
            if (this.routeParams.id === 'novo') {
                this.onDataChanged.next(false);
                resolve(false);
            }
            else {
                this.gw.get('occupationTiss/' + this.routeParams.id).subscribe((res: OccupationTiss ) => {
                    this.occupationTiss = res;
                    this.onDataChanged.next(this.occupationTiss);
                    resolve(res);
                }, reject);
            }
        });
    }

    insert(occupationTiss): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('occupationTiss/', occupationTiss).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    edit(occupationTiss): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.put('occupationTiss/', occupationTiss).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    delete(occupationTiss): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.delete('occupationTiss/' + occupationTiss.id).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                 this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }
}
